<script>
    import { faGoogle, faFacebook } from "@fortawesome/free-brands-svg-icons";
    import Icon from "fa-svelte";
    import { signIn, signInWithGoogle } from "../stores/user";
    import { slide } from "svelte/transition";
    import { handleAsync } from "../common/safe_promise";

    let email = "";
    let password = "";

    const handleSubmit = handleAsync(() => {
        signIn(email, password);
    });

    const googleLogin = handleAsync(() => {
        signInWithGoogle();
    });
</script>

<style>
    form {
        width: 350px;
        max-width: 90vw;
    }
</style>

<main class="flex flex-col items-center space-y-4 p-4">
    <h1>Welcome</h1>
    <h2>Please log in</h2>
    <form
        class="flex flex-col"
        action="none"
        on:submit|preventDefault={handleSubmit}>
        <label for="email">Email</label>
        <input type="text" id="email" bind:value={email} />
        <label class="mt-4" for="password">Password</label>
        <input type="password" id="password" bind:value={password} />
        <button class="mt-4" type="submit">Log in</button>
        <div class="flex justify-center mt-4">
            <button
                class="bg-white text-gray-700 rounded-full border-gray-500
                border w-10 h-10 flex justify-center items-center"
                type="none"
                on:click={googleLogin}>
                <Icon icon={faGoogle} />
            </button>
        </div>
    </form>
</main>
